import { HazardType, useHazardsStore, useMapStore } from '@/features';
import messagesEnCA from '@/locales/messages/en-CA.json';
import messagesFrCA from '@/locales/messages/fr-CA.json';
import localeCode from 'locale-code';
import { Settings } from 'luxon';
import { computed, watch } from 'vue';
import { createI18n } from 'vue-i18n';

const fallbackLocale = 'en-CA';

export const i18n = createI18n({
  locale: localStorage.getItem('locale') || fallbackLocale,
  fallbackLocale: fallbackLocale,
  legacy: false,
  messages: {
    'en-CA': messagesEnCA,
    'fr-CA': messagesFrCA,
  },
});

// Update the default locale for Luxon
Settings.defaultLocale = i18n.global.locale.value;

watch(i18n.global.locale, async (newLocale) => {
  // eslint-disable-next-line no-console
  console.log('Locale changed to:', newLocale);

  localStorage.setItem('locale', newLocale);
  Settings.defaultLocale = newLocale;

  await useHazardsStore().fetchAllHazards([
    HazardType.Event,
    HazardType.Warning,
    HazardType.Incident,
    HazardType.Closure,
    HazardType.Centre,
  ]);

  // change the mapbox language
  const languageCode = newLocale.split('-')[0];
  useMapStore().setLanguage(languageCode);
});

export const currentLocaleName = computed(() => localeCode.getLanguageNativeName(i18n.global.locale.value));
